<template>
    <div style="width: 100%; height: 100%">
        <main-layout>
            <template #header>
                <main-header :title="'모바일 메뉴얼' | translate"/>
            </template>
            <template #body>
                <div class="flex-style-row">
                    <!--좌측 메뉴 관련 부분입니다.-->
                    <div class="box-style-border menus-list-style menus-container">
                        <div class="root-add-row">
                            <button
                                v-if="!showRootAddBar"
                                type="button"
                                class="root-add-btn"
                                @click.prevent="openRootAddBar"
                            >
                                <span class="root-add-icon" aria-hidden="true">+</span>
                                최상위 추가
                            </button>
                            <div v-else class="root-add-inline">
                                <input
                                    v-model.trim="rootNewTitle"
                                    type="text"
                                    class="root-add-input"
                                    placeholder="제목"
                                    @keyup.enter="submitRootDepth1Insert"
                                />
                                <button
                                    type="button"
                                    class="root-add-submit"
                                    title="등록"
                                    @click.prevent="submitRootDepth1Insert"
                                >
                                    +
                                </button>
                                <button
                                    type="button"
                                    class="root-add-cancel"
                                    @click.prevent="closeRootAddBar"
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                        <div v-if="depth2AddParent" class="root-add-row depth2-add-row">
                            <p class="depth2-add-hint">2뎁스 추가 · 상위: {{ depth2AddParent.title || '(제목 없음)' }}</p>
                            <div class="root-add-inline">
                                <input
                                    v-model.trim="depth2NewTitle"
                                    type="text"
                                    class="root-add-input depth2-add-input"
                                    placeholder="2뎁스 제목"
                                    @keyup.enter="submitDepth2Insert"
                                />
                                <button
                                    type="button"
                                    class="root-add-submit"
                                    title="등록"
                                    @click.prevent="submitDepth2Insert"
                                >
                                    +
                                </button>
                                <button
                                    type="button"
                                    class="root-add-cancel"
                                    @click.prevent="cancelDepth2Add"
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                        <mobile-manual-tree-menu-slot
                            :tree-items-menus="treeItemsMenus"
                            @moving-select-detail="movingSelectDetail"
                            @moving-write-detail="movingWriteDetail"
                            @moving-manual-rq="movingManualRq"
                            :menus="menus"
                            :click-menu-id="clickMenuId"
                        />
                    </div>
                    <!--우측 상세 부분 입니다.-->
                    <div v-if="showDetail" class="flex-style-column box-style-border detail-container">
                        <mobile-manual-detail
                            :key="detailPanelKey"
                            :manual="manual"
                            :manual-write-data="manualWriteData"
                            :click-menu-depth="clickMenuDepth"
                            :allow-content-fields="manualContentEditable"
                            @change-write-data="changeWriteData"
                            @insert-data-rq="insertDataRq"
                            @update-data-rq="updateDataRq"
                        />
                    </div>
                </div>
            </template>
        </main-layout>
        <div class="loading_wrap" v-show="isLoading">
            <div class="loading"></div>
            <div class="loading"></div>
            <div class="loading"></div>
        </div>
    </div>
</template>


<script>

/**
 * 게시판 -> 모바일 메뉴얼 클릭 시 화면 (NewManual.vue 기반)
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import MobileManualDetail from "@/views/mobileManual/MobileManualDetail";
import arrayToTree from "@/utils/array-to-tree";
import MobileManualTreeMenuSlot from "@/views/mobileManual/MobileManualTreeMenuSlot";
import {PATH} from "@/constants";


export default {
    name: "MobileManual",
    components: {
        MainLayout,
        MainHeader,
        MobileManualDetail,
        MobileManualTreeMenuSlot,
    },
    data() {
        return {
            menus: [],
            /** 1뎁스 인라인 추가 입력줄 */
            showRootAddBar: false,
            rootNewTitle: '',
            /** 1뎁스에서 + 클릭 시: 2뎁스만 제목으로 등록 (상세 없음) */
            depth2AddParent: null,
            depth2NewTitle: '',
            manual: undefined,//api요청시 받아온 manual 정보를 저장합니다. 데이터를 수정 하지 않고 고유정보를 보관합니다.
            showDetail: false, //단순히 처음에 상세화면을 안보여주기 위함입니다.
            isLoading:false, //progress bar 를 동작하기 위함입니다.
            clickMenuDepth:undefined,//상세화면에서 완료 수정 삭제 버튼을 2depth 3depth 메뉴마다 구분하기위해 사용됩니다.
            clickMenuId:undefined,//클릭한 메뉴의 manualId를 저장합니다. 메뉴 색 변경할때 쓰입니다.
            manualWriteData:{ //상세화면에서 작성하고 수정하는 데이터들을 전부 여기서 관리합니다.
                content:undefined,
                subContent:undefined,
                title:undefined,
                showYn:false,
                parentId:undefined,
            }
        }
    },
    computed: {
        /**
         *  배열을 일차원 구조가 아니라 하이라키 구조로 만듭니다.
         * arrayToTree은 정재위 책임님이 제공해주신 메서드로 확용했습니다.
         * @returns {[]|*}
         */
        treeItemsMenus() {
            if (!this.menus || !this.menus.length) return []
            const copy = JSON.parse(JSON.stringify( this.menus)); //깊은 복사 안하면 arrayToTree에서 값이 이상하게 나옵니다.
            const menusTree = arrayToTree(copy,
                {idKey: "manualId", parentKey: "parentId"})

            /**
             * depth가 1인 메뉴 depth가 2인 메뉴 전부 sequence에 맞게 오름차순 정렬을 합니다.
             */
            menusTree.sort((a, b)=> a.sequence - b.sequence)
            menusTree.forEach((menu)=>{
                if(!!menu.children) {
                    menu.children.sort((a, b)=> a.sequence - b.sequence)
                    menu.children.forEach((childrenMenu)=>{
                        if(!!childrenMenu.children) {
                            childrenMenu.children?.sort((a, b)=> a.sequence - b.sequence)
                        }
                    })
                }
            })
            return menusTree
        },
        /** 상세(Quill)가 편집 중인 행이 바뀔 때 컴포넌트 재마운트 — watch 루프·에디터 꼬임 방지 */
        detailPanelKey() {
            if (!this.manual) return 'detail-empty'
            return `m-${this.manual.manualId}-d-${this.manual.depth != null ? this.manual.depth : 'x'}`
        },
        /** 본문·부가내용은 DB 3뎁스(및 그에 해당하는 신규 초안)만 */
        manualContentEditable() {
            const m = this.manual
            if (!m || typeof m !== "object") return false
            return this.rowDepth(m) === 3
        },

    },
    watch: {
        /**
         * manual이 바뀔때마다 (select 단건조회, manual insert)
         * manualWriteData를 바꿉니다.
         */
        manual:{
            immediate:true,
            handler(newValue){
                if(!newValue) return;
                let { title, content, subContent, showYn, parentId } = newValue
                const d = this.rowDepth(newValue)
                if (d !== 3) {
                    content = undefined
                    subContent = ''
                } else if (subContent == null) {
                    subContent = ''
                }
                this.manualWriteData = {
                    title,
                    content,
                    subContent,
                    parentId,
                    showYn: showYn === 'Y',
                }
            }
        }
    },
    methods: {
        manualDepthOrDefault() {
            if (this.manual && this.manual.depth != null) return this.manual.depth
            return 3
        },
        /** depth 미상일 때 본문 편집 허용으로 오인하지 않도록 기본은 undefined */
        rowDepth(row) {
            if (row && row.depth != null) return row.depth
            return undefined
        },
        /**
         * 메뉴얼에대한 부분을 초기화 하기위해 만들었습니다.
         */
        init() {
            this.manualWriteData ={
                parentId:undefined,
                content:undefined,
                subContent:undefined,
                title:undefined,
                showYn:false
            }
        },
        /**
         * 제목이랑 내용을 작성할대 emit으로 받은 데이터를 manualWriteData에 넣습니다.
         * @param newValue
         */
        _normWriteField(v) {
            if (v === undefined || v === null) return null
            if (typeof v === 'string' && v.trim() === '') return null
            return v
        },
        _sameManualWriteData(merged, cur) {
            const p = (x) => (x == null ? null : x)
            return (
                this._normWriteField(merged.title) === this._normWriteField(cur.title) &&
                this._normWriteField(merged.content) === this._normWriteField(cur.content) &&
                this._normWriteField(merged.subContent) === this._normWriteField(cur.subContent) &&
                !!merged.showYn === !!cur.showYn &&
                p(merged.parentId) === p(cur.parentId)
            )
        },
        /**
         * MobileManualDetail innerManual → emit 시 매번 새 객체를 만들면
         * 자식 manualWriteData watch ↔ innerManual watch 가 무한에 가깝게 돌 수 있어 동일하면 갱신 생략
         */
        changeWriteData(newValue) {
            const merged = { ...this.manualWriteData, ...newValue }
            if (this._sameManualWriteData(merged, this.manualWriteData)) return
            this.manualWriteData = merged
        },
        /**
         * plus 버튼을 클릭시 동작하고
         * 작성하는 상세창을 열어줍니다.
         * 비어있는 메뉴얼 메뉴를 생성해주는데 중복으로는 생성 불가하고
         * 다른메뉴의 +버튼을 클릭하면 이전 비어있는 메뉴얼 메뉴가 사라집니다.
         *
         */
        /**
         * @param clickMenu 부모 노드
         * @param parentTreeDepth 트리 상 부모 depth (루트=1). 자식 DB depth = parentTreeDepth + 1
         */
        openRootAddBar() {
            this.cancelDepth2Add()
            this.showRootAddBar = true
            this.rootNewTitle = ''
            this.$nextTick(() => {
                const el = this.$el && this.$el.querySelector && this.$el.querySelector('.root-add-input')
                if (el) el.focus()
            })
        },
        closeRootAddBar() {
            this.showRootAddBar = false
            this.rootNewTitle = ''
        },
        cancelDepth2Add() {
            this.depth2AddParent = null
            this.depth2NewTitle = ''
        },
        /**
         * 1뎁스 노드에서 + 로 추가하는 2뎁스: 제목만 저장, 상세 패널 없음
         */
        async submitDepth2Insert() {
            if (!this.depth2NewTitle) {
                this.$alert('제목을 입력해 주세요.')
                return
            }
            if (!this.depth2AddParent || this.depth2AddParent.manualId == null) return
            try {
                await this.requestComplete({
                    parentId: this.depth2AddParent.manualId,
                    sequence: this.lastSequence(this.depth2AddParent.manualId),
                    depth: 2,
                    title: this.depth2NewTitle,
                    content: '',
                    subContent: '',
                    showYn: 'N',
                }, { silent: true })
                await this.requestMenuData({ silent: true })
                this.cancelDepth2Add()
            } catch (e) {
                /* requestComplete에서 알림 */
            }
        },
        /**
         * 1뎁스 인라인 등록: 목록 전체 리프레시용 로딩 오버레이 없이 insert 후 조용히 목록만 갱신
         */
        async submitRootDepth1Insert() {
            if (!this.rootNewTitle) {
                this.$alert('제목을 입력해 주세요.')
                return
            }
            try {
                await this.requestComplete({
                    parentId: null,
                    sequence: this.lastSequence(null),
                    depth: 1,
                    title: this.rootNewTitle,
                    content: '',
                    subContent: '',
                    showYn: 'N',
                }, { silent: true })
                await this.requestMenuData({ silent: true })
                this.closeRootAddBar()
            } catch (e) {
                /* requestComplete에서 알림 */
            }
        },
        /** 목록 API 응답 → 플랫 배열 (ListBody 또는 배열) */
        normalizeManualList(res) {
            if (res == null) return []
            if (Array.isArray(res)) return res
            if (typeof res === 'object' && Array.isArray(res.data)) return res.data
            return []
        },
        /** 저장 전 임시 행(manualId -1)만 로컬에서 제거 — NewManual은 + 클릭 시 list API로 동기화했으나 모바일은 호출하지 않음 */
        dropLocalBlankDrafts() {
            if (!Array.isArray(this.menus)) return
            this.menus = this.menus.filter((m) => m.manualId !== -1)
        },
        /**
         * 트리 + 클릭: depth 1 → 2뎁스는 제목만(좌측 인라인), depth 2 → 3뎁스만 상세(본문·부가)
         * @param clickMenu 부모 노드
         * @param parentTreeDepth 트리 UI depth (1뎁스 행=1, 2뎁스 행=2)
         */
        movingWriteDetail(clickMenu, parentTreeDepth = 2) {
            this.clickMenuId = undefined
            if (!Array.isArray(this.menus)) this.menus = []

            /* 1뎁스에서 + : 상세 없이 2뎁스 제목만 */
            if (parentTreeDepth === 1) {
                this.dropLocalBlankDrafts()
                this.showDetail = false
                this.manual = undefined
                this.clickMenuDepth = undefined
                this.init()
                this.closeRootAddBar()
                this.depth2AddParent = clickMenu
                this.depth2NewTitle = ''
                this.$nextTick(() => {
                    const el = this.$el && this.$el.querySelector && this.$el.querySelector('.depth2-add-input')
                    if (el) el.focus()
                })
                return
            }

            const childDbDepth = parentTreeDepth + 1
            const parentManualId = clickMenu.manualId == null ? null : clickMenu.manualId

            const perform = () => {
                this.showDetail = true
                this.clickMenuDepth = 2
                this.init()
                this.manualWriteData.parentId = parentManualId == null ? undefined : parentManualId
            }
            const blankManualMenu = () => {
                let seq = 0
                if (clickMenu.children && clickMenu.children.length > 0) {
                    seq = clickMenu.children[clickMenu.children.length - 1].sequence
                }
                seq++
                const newItem = {
                    content: '',
                    deleteYn: 'N',
                    depth: childDbDepth,
                    locale: "ko-KR",
                    manualId: -1,
                    modifier: '',
                    parentId: parentManualId,
                    register: '',
                    sequence: seq,
                    showYn: 'N',
                    title: '',
                    subContent: '',
                }
                this.menus.push(newItem)
                this.manual = newItem
            }
            this.cancelDepth2Add()
            this.dropLocalBlankDrafts()
            perform()
            blankManualMenu()
        },


        /**
         * 3depth에 있는 메뉴얼을 클릭시 해당 조건을 수행후 맞다면 아래 perform 동작을 수행합니다.
         * 1. 상세창 보여주기
         * 2. 메뉴 데이터 업데이트
         * 3. 메뉴얼 데이터 업데이트
         */
        movingSelectDetail(clickManualMenu) {
            const perform = ()=>{
                this.cancelDepth2Add()
                this.clickMenuId = clickManualMenu.manualId
                this.showDetail = true
                // 기존 행 편집: DB depth 2·3 모두 수정/삭제 UI(3) 사용 (본문은 3뎁스만)
                this.clickMenuDepth = 3
                this.manualWriteData.parentId=clickManualMenu.parentId
                /** 단건 조회 전에도 depth 기준으로 본문 영역 노출이 맞도록 */
                this.manual = { ...clickManualMenu }
                this.requestMenuData()
                this.requestManualData(clickManualMenu.manualId)
            }
            /**
             * 메뉴얼을 클릭시 dialog 가 나오는지에 대한 여부랑 위에 조건을 수행하는지에
             * 대한 여부를 판별합니다.
             * @type {boolean}
             */

            //같은 메뉴얼인지 판별하고 맞다면 perform 동작을 안합니다.
            const sameManualClick = !!this.manual && this.manual.manualId ===clickManualMenu.manualId
            //비어있는 메뉴는 클릭할 수 없습니다.
            const blankManualClick = clickManualMenu.manualId === -1
            if(sameManualClick || blankManualClick) return //같은 메뉴일때는 동작 안하게 하기
            //dialog 를 보여줄지에 대한 판별을 합니다. 1. 상세창이 나와있는 경우 2.보여진 메뉴얼과 클릭한 메뉴얼이 다른 경우
            const showDialog = this.showDetail
            if(showDialog){
                this.$confirm(`${clickManualMenu.title} 메뉴로 이동 하시겠습니까?`)
                    .then(() => perform())
                    .catch(() => { /* 취소: 미이동 */ })
            }else{
                perform()//다른 메뉴일때 동작
            }
        },


        /**
         * 작성 완료버튼을 클릭했을때 동작합니다.
         * 메뉴얼 데이터를 업데이트 해줍니다.
         * 상세창을 닫습니다.
         */
        async insertDataRq() {
            const bodyData={
                parentId: this.manualWriteData.parentId != null ? this.manualWriteData.parentId : null,
                sequence: this.lastSequence(this.manualWriteData.parentId),
                depth: this.manualDepthOrDefault(),
                title:this.manualWriteData.title,
                content:this.manualWriteData.content,
                subContent: this.manualWriteData.subContent,
                showYn: this.manualWriteData.showYn?'Y':'N'
            }
            await this.requestComplete(bodyData)
            await this.requestMenuData()
            this.clickMenuId=undefined
            this.showDetail = false
            this.manual=undefined
        },
        /**
         * insertDataRq 에서 sequence를 찾는 부분이고
         * parentId를 받아서 클릭한 메뉴를 찾고 그 메뉴에서 여러 메뉴얼중
         * 마지막 sequence를 구해 반환합니다.
         */
        lastSequence(parentId){
            const sameParent = (menu) => {
                const p = menu.parentId
                if (parentId == null) return p == null || p === undefined
                return p === parentId
            }
            const sameManual = (this.menus || []).filter(sameParent)
            const sequence = sameManual.length
                ? sameManual[sameManual.length - 1].sequence + 1
                : 1
            return sequence
        },

        /**
         * 수정 완료 버튼 클릭시랑 삭제 버튼을 클릭했을때 동작합니다.
         * 삭제완료시에는 상세창을 닫습니다.
         */
        async updateDataRq(deleteYn) {
            const rowDepth = this.manualDepthOrDefault()
            const stripBody = rowDepth === 2
            const bodyData={
                manualId:this.manual.manualId,
                parentId: this.manualWriteData.parentId,
                sequence:this.manual.sequence, //배열의 마지막 번호 구해야됩니다.
                depth: rowDepth,
                title:this.manualWriteData.title,
                content: stripBody ? '' : (this.manualWriteData.content != null ? this.manualWriteData.content : ''),
                subContent: stripBody ? '' : (this.manualWriteData.subContent != null ? this.manualWriteData.subContent : ''),
                showYn: this.manualWriteData.showYn?'Y':'N',
                deleteYn:deleteYn
            }
            await this.requestUpdate(bodyData)
            await this.requestMenuData()
            this.clickMenuId=undefined
            this.showDetail = false
            this.manual=undefined
        },
        /**
         * 클릭한 메뉴(clickMenu), 바꾸려는 메뉴(menuStatus)를
         * sequence만 바꿔서 update요청을 보냅니다.
         */
        async movingManualRq(clickMenu,menuStatus){
            const depthA = clickMenu.depth != null ? clickMenu.depth : 3
            const depthB = menuStatus.depth != null ? menuStatus.depth : 3
            const bodyDataA={
                manualId:clickMenu.manualId,
                parentId: clickMenu.parentId,
                sequence:menuStatus.sequence,
                depth: depthA,
                title:clickMenu.title,
                content:clickMenu.content,
                subContent: clickMenu.subContent,
                showYn: clickMenu.showYn,
                deleteYn:clickMenu.deleteYn
            }
            const bodyDataB={
                manualId:menuStatus.manualId,
                parentId: menuStatus.parentId,
                sequence:clickMenu.sequence,
                depth: depthB,
                title:menuStatus.title,
                content:menuStatus.content,
                subContent: menuStatus.subContent,
                showYn: menuStatus.showYn,
                deleteYn:menuStatus.deleteYn
            }
            await this.requestUpdate(bodyDataA)
            await this.requestUpdate(bodyDataB)
            await this.requestMenuData()
        },


        /**
         * 메뉴을 요청 받는 부분입니다.
         * @returns {Promise<void>}
         */
        /**
         * @param {Object} opts silent: true 이면 전체 화면 로딩(isLoading) 사용 안 함
         */
        async requestMenuData(opts = {}) {
            const silent = opts.silent === true
            if (!silent) this.isLoading = true
            try {
                const res = await this.$request(PATH.MOBILE_MANUAL.LIST).get().enqueue()
                this.menus = this.normalizeManualList(res)
            } catch (e) {
                this.menus = Array.isArray(this.menus) ? this.menus : []
                alert('조회실패')
            } finally {
                if (!silent) this.isLoading = false
            }
        },
        /**
         * 각 저장된 메뉴얼 메뉴마다 클릭시 데이터 베이스에서 저장된 메뉴얼을 가지고 옵니다.
         * @returns {Promise<void>}
         */
        async requestManualData(menuId) {
            this.isLoading=true;
            const res = await this.$request(`${PATH.MOBILE_MANUAL.DETAIL}/${menuId}`)
                .get()
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;
            this.manual=res

        },
        /**
         * insert 요청 하는 부분입니다
         * @param bodyData
         * @returns {Promise<void>}
         */
        /**
         * @param {Object} opts silent: true 이면 전체 화면 로딩 사용 안 함
         */
        async requestComplete(bodyData, opts = {}) {
            const silent = opts.silent === true
            if (!silent) this.isLoading = true
            try {
                await this.$request(PATH.MOBILE_MANUAL.INSERT)
                    .setObject({ ...bodyData })
                    .enqueue()
            } catch (e) {
                alert('저장에 실패했습니다.')
                throw e
            } finally {
                if (!silent) this.isLoading = false
            }
        },
        /**
         * update요청하는 부분입니다.
         * @returns {Promise<void>}
         */
        async requestUpdate(bodyData) {
            this.isLoading=true;
            await this.$request(PATH.MOBILE_MANUAL.UPDATE)
                .setObject({
                    ...bodyData
                })
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;

        }


    },
    mounted() {
        this.requestMenuData()

    }
}
</script>

<style scoped>
/*공통으로 사용하는 Css 부분입니다*/
.flex-style-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.flex-style-row {
    display: flex;
    height: 100%;
}

/*메뉴랑 상세부분 border 스타일 부분*/
.box-style-border {
    border: 1px solid #9f9f9f;
    border-radius: 10px;
}


/*메뉴 컨테이너*/
.menus-list-style {
    list-style: none;
}

.menus-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 250px;
    overflow: auto
}

.root-add-row {
    width: 100%;
    padding: 8px 10px;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.root-add-btn {
    display: inline-flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding: 8px 10px;
    font-size: 12px;
    cursor: pointer;
    border: 1px dashed #9f9f9f;
    border-radius: 6px;
    background: #f7f9fc;
    color: #1976d2;
}

.root-add-btn:hover {
    background: #e3f2fd;
    border-color: #1976d2;
}

.root-add-icon {
    margin-right: 6px;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
}

.root-add-inline {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.root-add-input {
    flex: 1;
    min-width: 0;
    padding: 6px 8px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.root-add-submit {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background: #1976d2;
    color: #fff;
}

.root-add-submit:hover {
    background: #1565c0;
}

.root-add-cancel {
    flex-shrink: 0;
    padding: 6px 8px;
    font-size: 11px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    color: #555;
}

.root-add-cancel:hover {
    background: #f5f5f5;
}

.depth2-add-row {
    border-bottom: 1px solid #e3f2fd;
    background: #f7fbff;
}

.depth2-add-hint {
    margin: 0 0 6px 0;
    font-size: 11px;
    color: #1565c0;
    line-height: 1.3;
    word-break: break-all;
}

/*상세 컨테이너*/
.detail-container {
    margin-left: 1rem;
    width: 80%;
    height: 100%;
    padding: 20px;
}

/*로딩 부분입니다.*/
.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0,0,0,0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}
@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}


</style>
